import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';

export const ConvertArrayToXML = (objArray, root, child) => {
    let xml = root;
    objArray.forEach(item => {
        if(child){
          xml += child;
        }
        for (let key in item) {
          xml += `<${key}>${item[key]}</${key}>`;
        }
        if(child){
          xml += child.replace('<','</');
        }
    });
    xml += root.replace('<','</');
    return xml;
};

export const getStorageValues = (storageKey) => {
  var returnValue = "";
  if(storageKey === "userId") {
    returnValue = localStorage.getItem('userId') || sessionStorage.getItem('userId');
  } else if(storageKey === "user") {
    returnValue = localStorage.getItem('user') || sessionStorage.getItem('user');
  } else if(storageKey === "userRole") {
    returnValue = localStorage.getItem('userRole') || sessionStorage.getItem('userRole');
  } else if(storageKey === "token") {
    returnValue = localStorage.getItem('token') || sessionStorage.getItem('token');
  } else if(storageKey === "roleId") {
    returnValue = localStorage.getItem('roleId') || sessionStorage.getItem('roleId');
  } else if(storageKey === "IsAdmin") {
    returnValue = localStorage.getItem('IsAdmin') || sessionStorage.getItem('IsAdmin');
  }
  return returnValue;
};


export const getCompanyInfo = async () => {
  const companyId = process.env.REACT_APP_COMPANY_ID;
  try {
    
      let selectedCompany = {
          UserId: localStorage.getItem("userId")
      };
      const response = await axios.get(getApiBaseUrl() + "/companylist", {params: selectedCompany});
      if (response.status === 200) {
          return response.data.data[0].find(c => c.CompanyId.toString() === companyId);
      }
  } catch (error) {
      console.log(error);
  }
};

export const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (isNaN(date.getTime())) return value;
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

